import { Checkbox } from "../../../Checkbox";
import * as s from "../../FilterBar.style.css";
import type { CheckboxQuickFilterConfig } from "../../FilterBar.types";
import type { QuickFilterVariant } from "../QuickFilterControl";

export interface CheckboxFilterProps {
  config: CheckboxQuickFilterConfig;
  value: unknown;
  onChange: (v: unknown) => void;
  variant?: QuickFilterVariant;
}

export function CheckboxFilter({ config, value, onChange, variant = "bar" }: CheckboxFilterProps) {
  const checked = value === true;
  const isModal = variant === "modal";
  return (
    <div className={isModal ? s.quickFiltersModalFilterRow : s.quickFilterItem}>
      <label className={s.quickFilterCheckbox}>
        <Checkbox
          checked={checked}
          onCheckedChange={(v) => onChange(v ? true : undefined)}
        />
        <span className={isModal ? s.quickFiltersModalLabel : s.quickFilterLabel}>{config.label}</span>
      </label>
    </div>
  );
}
